<style src="./InputSuggestItem.scss" lang="scss" scoped></style>
<template>
  <li
    @click="chooseItem"
    :class="{'selected': iAmSelected}">
    <slot />
  </li>
</template>

<script>
export default {
  name: 'InputSuggestItem',
  props: {
    item: {
      default: null
    },
    idx: null
  },
  data () {
    return {}
  },
  computed: {
    iAmSelected () {
      const selectedIdx = this.$parent.$parent.selectedItemIdx
      return selectedIdx === this.idx
    }
  },
  methods: {
    chooseItem () {
      this.$parent.$parent.selectingItemFromSuggestList(this.item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/input-suggest/input-suggest-item/InputSuggestItem.vue